<svelte:options tag={null} />

<script lang="ts">
  import type { ListboxItems } from './listbox.types';
  import { EventHandler } from '../../utilities/EventHandler';

  export let items: string;
  export let value: any;
  export let open: boolean;
  export let multiple: boolean;
  export let isfiltered: boolean;
  export let emptysearchlabel = 'No results found';
  export let datatextexpr = 'label';
  export let datavalueexpr = 'value';
  export let datadisabledexpr = 'disabled';
  export let maxwidth = '100%';

  const uuid = Math.random();
  let eventHandler = new EventHandler();

  $: parsedItems = items ? (JSON.parse(items) as ListboxItems[]) : [];

  function setItemId(index: number) {
    return `listboxItem-${index + uuid}`;
  }

  function scrollEnd(node: HTMLElement) {
    node.addEventListener('scroll', () => {
      if (node.offsetHeight + node.scrollTop >= node.scrollHeight) {
        eventHandler.dispatch('scrollend', {});
      }
    });
  }
</script>

<ul
  role="listbox"
  class="mc-listbox"
  class:is-open={open}
  class:mc-listbox--multi={multiple}
  aria-labelledby="listbox"
  style="--listbox-width: {maxwidth};"
  use:scrollEnd
>
  {#if !isfiltered}
    {#each parsedItems as item, index}
      <li class="mc-listbox__item" class:is-disabled={item[datadisabledexpr]}>
        {#if !multiple}
          <input
            id={setItemId(index)}
            class="mc-listbox__input"
            class:is-disabled={item[datadisabledexpr]}
            type="radio"
            value={item[datavalueexpr]}
            name={`listboxradio-${uuid}`}
            disabled={Boolean(item[datadisabledexpr])}
            bind:group={value}
            on:change
          />
        {:else}
          <input
            id={setItemId(index)}
            class="mc-listbox__input mc-checkbox__input"
            type="checkbox"
            value={item[datavalueexpr]}
            checked={value.includes(item[datavalueexpr])}
            disabled={Boolean(item[datadisabledexpr])}
            bind:group={value}
            on:change
          />
        {/if}

        <label for={setItemId(index)} class="mc-listbox__label">
          {item[datatextexpr]}
        </label>
      </li>
    {/each}
  {:else}
    <li class="mc-listbox__item">
      <span class="mc-listbox__empty">{emptysearchlabel}</span>
    </li>
  {/if}
</ul>

<style lang="scss">
  @import '@mozaic-ds/styles/settings-tools/all-settings';
  @import '@mozaic-ds/styles/components/c.checkbox';
  @import '@mozaic-ds/styles/components/c.listbox';
</style>
